export const DELIMITER = '•';
export const POSITIVE_DIFF = '↑';
export const NEGATIVE_DIFF = '↓';
export const NO_COMPARISON = '--';
export const NO_CHANGE = '-';
